import axios from "axios";
import { API_DOMAIN } from "../constants";

const authConfig = () => ({ headers: { accessToken: localStorage.getItem("accessToken") } });
const dataOf = response => response?.data?.data;

export async function fetchInternalChatUsers() {
  const response = await axios.get(`${API_DOMAIN}/auth/get_all_users`, authConfig());
  return dataOf(response) || [];
}

export async function fetchConversations() {
  const response = await axios.get(`${API_DOMAIN}/internal_chat/conversations`, authConfig());
  return dataOf(response) || [];
}

export async function ensureDirectConversation(userId) {
  const response = await axios.post(`${API_DOMAIN}/internal_chat/conversations/direct`, { user_id: userId }, authConfig());
  return dataOf(response);
}

export async function fetchConversationMessages(conversationId, params = {}) {
  const response = await axios.get(`${API_DOMAIN}/internal_chat/conversations/${conversationId}/messages`, { ...authConfig(), params });
  return dataOf(response) || [];
}

export async function syncInternalMessages(afterId, limit = 200) {
  const response = await axios.get(`${API_DOMAIN}/internal_chat/sync`, {
    ...authConfig(),
    params: { after_id: afterId || 0, limit },
  });
  return dataOf(response) || { messages: [], next_after_id: afterId || 0, has_more: false };
}

export async function sendInternalMessage(conversationId, payload) {
  const response = await axios.post(`${API_DOMAIN}/internal_chat/conversations/${conversationId}/messages`, payload, authConfig());
  return dataOf(response);
}

export async function markConversationDelivered(conversationId, throughMessageId) {
  return axios.post(`${API_DOMAIN}/internal_chat/conversations/${conversationId}/delivered`, { through_message_id: throughMessageId }, authConfig());
}

export async function markConversationRead(conversationId, throughMessageId) {
  return axios.post(`${API_DOMAIN}/internal_chat/conversations/${conversationId}/read`, { through_message_id: throughMessageId }, authConfig());
}

export async function initiateInternalUpload(file) {
  const response = await axios.post(`${API_DOMAIN}/cloud_storage/uploads/initiate`, {
    original_name: file.name,
    mime_type: file.type,
    size_bytes: file.size,
  }, authConfig());
  return dataOf(response);
}

export function putSignedUpload({ uploadUrl, requiredHeaders, file, onProgress }) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", uploadUrl, true);
    Object.entries(requiredHeaders || {}).forEach(([name, value]) => xhr.setRequestHeader(name, value));
    xhr.upload.onprogress = event => {
      if (event.lengthComputable) onProgress?.(Math.round((event.loaded / event.total) * 100));
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error(`Upload failed with status ${xhr.status}.`));
    };
    xhr.onerror = () => reject(new Error("Upload failed due to a network error."));
    xhr.send(file);
  });
}

export async function completeInternalUpload(uploadId) {
  const response = await axios.post(`${API_DOMAIN}/cloud_storage/uploads/${uploadId}/complete`, {}, authConfig());
  return dataOf(response);
}

export async function getInternalFileDownload(fileId) {
  const response = await axios.get(`${API_DOMAIN}/internal_chat/files/${fileId}/download-url`, authConfig());
  return dataOf(response);
}
